var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{on:{"click":_vm.toggleClick}},[(_vm.isActive)?_c('svg-icon',{staticClass:"hamburger",staticStyle:{"color":"#000","width":"25px","height":"30px"},attrs:{"icon-class":"th-laddersimple"}}):_c('svg-icon',{staticClass:"hamburger",staticStyle:{"color":"#000","width":"25px","height":"30px"},attrs:{"icon-class":"th-ladder"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52bcdfb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hamburger/index.vue
// module id = null
// module chunks = 